import type { ICache, ICacheController } from '../interface/cache';
import Cache from './cache';

const kCacheKey = '__cache';

function _isCache(object: unknown): object is ICache {
    const isNullOrUndefined = (value: unknown): boolean => value === null || value === undefined;

    if (isNullOrUndefined(object) || typeof object !== 'object') {
        return false;
    }

    const record: Partial<ICache> = object as Partial<ICache>;

    return !isNullOrUndefined(record.add) && !isNullOrUndefined(record.get);
}

function _get(associatedObject: unknown): ICache | null {
    if (
        !associatedObject ||
        typeof associatedObject !== 'object' ||
        !Object.isExtensible(associatedObject)
    ) {
        return null;
    }

    const searchObject = associatedObject as Record<symbol, unknown>;

    const keySearch: symbol = Symbol.for(kCacheKey);
    const cacheExisting = searchObject[keySearch];
    const value = cacheExisting || Cache();

    if (!_isCache(value)) {
        return null;
    }

    searchObject[keySearch] = value;

    return value;
}

function CacheController(): ICacheController {
    const globalCacheObj = Cache();

    const controller: ICacheController = {
        getAssociatedCache: _get,
        getGlobalCache: () => globalCacheObj,
    };

    return controller;
}

export default CacheController;
